import parse from 'html-react-parser';
import styled from 'styled-components';
import icons from '../assets/icons';

const Wrapper = styled.div`
  margin: ${(props) => props.marg || 0};
  padding: ${(props) => props.pad || 0};
  width: ${(props) => `${props.dimensions || 24}px`};
  height: ${(props) => `${props.dimensions || 24}px`};
  box-sizing: content-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

//Valid props: dimensions, col, type, marg
const Icon = (props) => {
  const { type } = props;
  const xml = icons[type];

  if (!xml) return null;
  let icon = xml(props);

  return <Wrapper {...props}>{parse(icon)}</Wrapper>;
};

export default Icon;
